import type { AccountProfile } from '@/types/iam.types';

/**
 * 使用当前登录身份的 profile 校正用户名映射。
 *
 * ListUserNameMap 在 IAM 子用户场景下可能把 user id 映射为所属账号名；
 * GetAccountProfile.user 才是当前登录子用户的权威 id / username。
 */
export function mergeCurrentProfileUserName(
  userNames: Record<string, string>,
  profile?: AccountProfile
): Record<string, string> {
  const currentIdentity = profile?.user ?? profile?.account;
  const userId = currentIdentity?.id.trim();
  const username = currentIdentity?.name.trim();

  if (!userId || !username) {
    return userNames;
  }

  return {
    ...userNames,
    [userId]: username,
  };
}
